"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricaPixel = void 0;
const react_1 = __importDefault(require("react"));
const MetricaPixel = ({ tagID }) => (react_1.default.createElement("img", { height: "1", width: "1", style: { display: 'none' }, src: `https://mc.yandex.ru/watch/${tagID}`, alt: "" }));
exports.MetricaPixel = MetricaPixel;
//# sourceMappingURL=MetricaPixel.js.map